import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { formatDuration } from "../../../helper/formatDuration";

const PlaylistPreview = ({ playlist, type, className = '' }) => {

  const formatTrackCount = (count) => {
    return `${count} track${count !== 1 ? 's' : ''}`;
  };

  return (
    <div className={`bg-surface border border-border rounded-lg p-4 lg:p-6 ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <Icon 
          name={type === 'source' ? 'Music' : 'Play'} 
          size={20} 
          className={type === 'source' ? 'text-success' : 'text-error'} 
        />
        <h3 className="text-lg font-semibold text-text-primary">
          {type === 'source' ? 'Source Playlist' : 'Destination Platform'}
        </h3>
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
          type === 'source' ?'bg-success/10 text-success' :'bg-error/10 text-error'
        }`}>
          {type === 'source' ? 'Spotify' : 'YouTube Music'}
        </div>
      </div>

      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <Image
            src={playlist.coverImage}
            alt={`${playlist.name} cover`}
            className="w-16 h-16 lg:w-20 lg:h-20 rounded-lg object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-xl font-bold text-text-primary mb-2 truncate">
            {playlist.name}
          </h4>
          
          {playlist.description && (
            <p className="text-sm text-text-secondary mb-3 line-clamp-2">
              {playlist.description}
            </p>
          )}

          <div className="flex flex-wrap items-center gap-4 text-sm text-text-muted">
            <div className="flex items-center space-x-1">
              <Icon name="List" size={16} />
              <span>{formatTrackCount(playlist.trackCount)}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={16} />
              <span>{formatDuration(playlist.totalDuration)}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="User" size={16} />
              <span>by {playlist.owner}</span>
            </div>
          </div>

          {playlist.isPublic !== undefined && (
            <div className="mt-2">
              <div className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs ${
                playlist.isPublic 
                  ? 'bg-primary/10 text-primary' :'bg-surface-secondary text-text-muted'
              }`}>
                <Icon name={playlist.isPublic ? 'Globe' : 'Lock'} size={12} />
                <span>{playlist.isPublic ? 'Public' : 'Private'}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaylistPreview;